<template>
    <h5 class="card-title">
        <slot></slot>
    </h5>
</template>
<script charset="utf-8">
    export default {
        name: "CardTitle"
    }
</script>